<aside class="sidebar-left-content settings-sidebar" ng-include="'modules/company/settings/partials/sidebar_data.html'"></aside>

<section id="content" ng-controller="SettingController" ng-init="getSms()" ng-class="loading ? 'loading' : ''">
    
    <div class="chute chute-center allcp-form">
        <div class="center-block" style="margin-left:200px;">
            <div class="row">
                <div class="col-md-8" 
                    ng-repeat="item in data" 
                    ng-if="item.sms_send">
                    <h6>{{ item.name }} Adlı KargoAdımı Mesaj İçeriği
                        <span class="fs12 text-muted">
                            {{ item.sms.content.length }} Karakter
                        </span>
                        <div class="pull-right">
                            <a href="#" ng-click="addAttr('[Kargo Takip No]',item.sms)" class="fs13 text-primary underline">[Kargo Takip No]</a>
                            <a href="#" ng-click="addAttr('[Müşteri Adı]',item.sms)" class="fs13 text-primary underline">[Müşteri Adı]</a>
                            <a href="#" ng-click="addAttr('[Teslimat Müşteri Adı]',item.sms)" class="fs13 text-primary underline">[Teslimat Müşteri Adı]</a>
                            <a href="#" ng-click="addAttr('[Şirket Adı]',item.sms)" class="fs13 text-primary underline">[Şirket Adı]</a>
                            <a href="#" ng-click="addAttr('[Personel Adı]',item.sms)" class="fs13 text-primary underline">[Personel Adı]</a>
                            <a href="#" ng-click="addAttr('[Telefon Numarası]',item.sms)" class="fs13 text-primary underline">[Telefon Numarası]</a>
                        </div>
                    </h6>
                    <form ng-submit="saveSms(item)" class="form-horizontal">
                        <div class="form-group">
                            <label for="name21" class="field prepend-icon">
                                <textarea class="form-control gui-input br-light" style="height:100px;" ng-model="item.sms.content" rows="15" cols="15" required></textarea>
                                <label for="name21" class="field-icon">
                                    <i class="fa fa-envelope"></i>
                                </label>
                            </label>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary"> Güncelle</button>
                        </div>
                    <form>
                </div>
                <div class="col-md-4">
                    <p></p>
                </div>
            </div>
        </div>
    </div>

<div class="modal fade" id="delete" tabindex="-1" role="dialog" aria-labelledby="deleteLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h5 class="modal-title"> <strong> Dikkat!</strong></h5>
        </div>
        <div class="modal-body">
            <strong class="text-danger">
                <i class="fa fa-exclamation-triangle"></i> Yapacağınız silme işlemi geri alınamaz bir işlemdir.
            </strong>
            <p><strong>Silmek istediğinizden emin misiniz ? </strong> </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-danger" ng-click="deleteStep('','delete')" data-dismiss="modal">Sil</button>
        </div>
        </div>
    </div>
</div>
</section>
